import MenuButton from '../MenuButton.jsx'
import useMenuItemDashboardEr from './useMenuItemDashboardEr.jsx'
import useMenuItemDashboardFlow from './useMenuItemDashboardFlow.jsx'
import useMenuItemDashboardModule from './useMenuItemDashboardModule.jsx'
import useMenuItemDashboardUi from './useMenuItemDashboardUi.jsx'
import useMenuItemManifestCrud from '@/components/SoftwareMap/maps/NavigatorMap/useMenuItemManifestCrud.jsx'

export default function MenuButtonDashboard(props) {
    const items = [
        useMenuItemDashboardFlow(),
        useMenuItemDashboardUi(),
        useMenuItemDashboardEr(),
        useMenuItemManifestCrud(),
        useMenuItemDashboardModule(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            模型看板
        </MenuButton>
    )
}
